// Dados pessoais nunca saem do navegador na telemetria.
// - Filtros: o valor é mantido, com CPF/e-mail/números longos mascarados.
// - Buscas (texto livre, pode ser nome de aluno): só o TIPO do termo.

const EMAIL_G = /[^\s@]+@[^\s@]+\.[^\s@]+/g;
const CPF_G = /\b\d{3}\.?\d{3}\.?\d{3}-?\d{2}\b/g;
const NUMERO_G = /\d{5,}/g;

export function mascarar(valor) {
  if (valor === null || valor === undefined) return null;
  const s = String(valor)
    .slice(0, 500)
    .replace(EMAIL_G, "[email]")
    .replace(CPF_G, "[cpf]")
    .replace(NUMERO_G, "[numero]");
  return s.slice(0, 255);
}

export function classificarTermo(valor) {
  const v = String(valor ?? "").trim();
  if (!v) return null;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return "[email]";
  if (/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(v)) return "[cpf]";
  if (/^[\d.\-/\s]+$/.test(v)) return "[numero]";
  return "[texto]";
}
